import DuckEntity from './DuckEntity';

const duck = new DuckEntity('tasks');

const reducer = (state = duck.initialState, action) => {
  switch (action.type) {
    // If it fails to delete, it was already deleted, so let's remove it from the list
    case duck.types.DELETE_ERROR: {
      const newAction = {
        ...action,
        type: duck.types.DELETE_SUCCESS
      };

      return duck.reducer(state, newAction);
    }

    case duck.types.SAVE_SUCCESS: {
      const { payload: { result: { task: id }, entities: { tasks } }, stateKey } = action;
      const result = duck.reducer(state, action);
      // A match here tells us that we're on the dashboard
      const matches = stateKey.match(/user_id=(.*)/);

      if (matches) {
        const oldUserId = matches[1];
        const { user: { id: newUserId } } = tasks[id];

        // Check to see if the associated user was changed
        if (matches && (newUserId !== oldUserId)) {
          const newKey = `user_id=${newUserId}`;
          const newState = {
            ...result,
            [stateKey]: { ...result[stateKey], results: result[stateKey].results.filter((taskId) => taskId !== id) }
          };

          if (state[newKey]) {
            newState[newKey] = { ...state[newKey], results: state[newKey].results.concat(id) };
          }

          return newState;
        }
      }

      // If the task was marked completed, remove it from the list
      if (tasks[id].completed) {
        return {
          ...result,
          [stateKey]: { ...result[stateKey], results: result[stateKey].results.filter((taskId) => taskId !== id) }
        };
      }

      return result;
    }

    default:
      return duck.reducer(state, action);
  }
};

export const entity = {
  ...duck,
  reducer
};
